<template>
    <p class="mt-2 text-sm text-red-600" v-if="form.errors && form.errors.has(inputName)" v-text="form.errors.get(inputName)"></p>
</template>

<script>
    export default {
        props: ['form', 'inputName']
    }
</script>
